module.exports = __webpack_public_path__ + "static/media/foto1.0a9a1a57.png";